import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import React from 'react';
import MetaControl from 'Components/UI/Meta/MetaControl';
import TaxStrategyMetaOverride
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyMetaOverrideSet';
import {
  TaxStrategyDetailsContainer,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsContainer';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import TaxStrategyDetailsMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsMetaOverride';
import {
  TaxStrategyDetailsLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsLayout';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';

const TaxStrategySummaryTabLayout = () => {
  const { pageContentCollection } = usePageContentContext();
  const { activeTabResource } = useTabContentContext();
  const resource = activeTabResource.attr('summaryTab')?.resources()?.head();

  const taxStrategyDetailsRelationshipDataArr = resource?.relationship(fr.relationships.proposalScenarioTaxStrategyDetails.name)?.attr('data');

  return (
    <FDStack direction={'column'} spacing={3}>
      <MetaControl attrName={'title'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
      <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
      <BorderedTransparentBox padding={4} appearance={'outlined'}>
        {(taxStrategyDetailsRelationshipDataArr && pageContentCollection
          .included()
          .findResource(taxStrategyDetailsRelationshipDataArr[0])) ? (
            <MetaResourceRenderer
              metaOverrideSet={TaxStrategyDetailsMetaOverride}
              layout={TaxStrategyDetailsLayout}
              LayoutProps={{ fixedWidth: true }}
              resource={pageContentCollection
                .included()
                .findResource(taxStrategyDetailsRelationshipDataArr[0])}
            />
          ) : (
            resource.withRelationship(
              fr.relationships.proposalScenarioTaxStrategyDetails.name,
              (rel) => (
                <TaxStrategyDetailsContainer relationship={rel} fixedWidth />
              ),
              () => null,
            )
          )}

      </BorderedTransparentBox>
    </FDStack>
  );
};

TaxStrategySummaryTabLayout.defaultProps = {
};

TaxStrategySummaryTabLayout.propTypes = {
};

export default TaxStrategySummaryTabLayout;
